import { Tab } from '@scuf/common';
import { useTranslation } from 'react-i18next';
import 'styles/main.scss';
import 'styles/repaircenter.scss';
import { RmaReport, RmaSearch } from './components';
import useUser from 'helpers/hooks/useUser';

function RepairCenter() {
    const { user } = useUser();
    const { t } = useTranslation(['rmamanufatura', 'common']);

    const hasRelatorio = () => {
        const hasRelatorio = !!(user?.role === '1' || user?.role === '2');

        return hasRelatorio;
    };

    const tabRelatorio = [
        hasRelatorio() ? (
            <Tab.Pane title={t('RELATÓRIOS')}>
                <RmaReport />
            </Tab.Pane>
        ) : null
    ].filter(Boolean);

    return (
        <>
            <div className="container">
                <Tab defaultActiveIndex={0} className="tab-with-divider">
                    <Tab.Pane title={t('RMA')}>
                        <RmaSearch />
                    </Tab.Pane>
                    {tabRelatorio}
                </Tab>
            </div>
        </>
    );
}

export default RepairCenter;
